import { JSONRPCRequest } from '@portals/fetch-api';
import { makeRequestConfig } from './make-request-config';
export var loadUserPermissionsRequest = function (options) {
    return new JSONRPCRequest().makeRequest(makeRequestConfig(options));
};
